/**
 * 药店流向数据管理路由
 */

// 导入RouterView组件
import { RouterView } from 'vue-router'

const flowDataRoutes = {
  path: '/flow-data',
  name: 'FlowData',
  // 直接使用vue-router提供的RouterView组件
  component: RouterView,
  meta: { 
    title: '流向数据管理', 
    icon: 'BarChartOutlined', 
    permission: ['flow-data'] 
  },
  children: [
    {
      path: '',  // 空路径，表示/flow-data
      name: 'FlowDataIndex',
      component: () => import('@/views/flow-data/index'),
      meta: { 
        title: '流向数据概览', 
        keepAlive: true, 
        permission: ['flow-data'] 
      }
    },
    {
      path: 'detail',
      name: 'FlowDataDetail',
      component: () => import('@/views/flow-data/detail'),
      meta: {
        title: '流向数据详情',
        keepAlive: false,
        permission: ['flow-data']
        // Removed hidden: true to expose in menu
      }
    },
    {
      path: 'pure-sales',
      name: 'PureSales',
      component: () => import('@/views/flow-data/pure-sales'),
      meta: {
        title: '纯销数据',
        keepAlive: false,
        permission: ['flow-data'],
        channel: 'standard' // 标准渠道
      }
    },
    {
      path: 'pure-sales-detail',
      name: 'PureSalesDetail',
      component: () => import('@/views/flow-data/pure-sales-detail'),
      meta: {
        title: '纯销数据详情',
        keepAlive: false,
        permission: ['flow-data'],
        channel: 'special' // 特殊/详情渠道
      }
    },
    {
      path: 'delivery',
      name: 'Delivery',
      component: () => import('@/views/flow-data/delivery'),
      meta: { 
        title: '配送数据', 
        keepAlive: false, 
        permission: ['flow-data'] 
      }
    },
    {
      path: 'delivery-detail',
      name: 'DeliveryDetail',
      component: () => import('@/views/flow-data/delivery-detail'),
      meta: {
        title: '配送数据详情',
        keepAlive: false, 
        permission: ['flow-data'] 
      }
    },
    {
      path: 'inventory',
      name: 'Inventory',
      component: () => import('@/views/flow-data/inventory'),
      meta: { 
        title: '库存数据', 
        keepAlive: false,
        permission: ['flow-data'],
        channel: 'standard' // 标准渠道
      }
    },
    {
      path: 'inventory-detail',
      name: 'InventoryDetail',
      component: () => import('@/views/flow-data/inventory-detail'),
      meta: {
        title: '库存数据详情',
        keepAlive: false,
        permission: ['flow-data'],
        channel: 'special' // 特殊/详情渠道
      }
    },
    {
      path: 'return-detail',
      name: 'ReturnDetail',
      component: () => import('@/views/flow-data/return-detail'),
      meta: {
        title: '退货数据详情',
        keepAlive: false, 
        permission: ['flow-data'] 
      }
    },
    {
      path: '/raw-data',
      name: 'RawData',
      meta: { 
        title: '抓取数据记录', 
        keepAlive: true, 
        permission: ['flow-data'] 
      },
      redirect: '/raw-data/list',
      children: [
        {
          path: '/raw-data/list',
          name: 'RawDataList',
          component: () => import('@/views/raw-data/list'),
          meta: { 
            title: '原始数据列表', 
            keepAlive: true, 
            permission: ['flow-data'] 
          }
        },
        {
          path: '/raw-data/detail',
          name: 'RawDataDetail',
          component: () => import('@/views/raw-data/detail'),
          meta: { 
            title: '原始数据详情', 
            keepAlive: false, 
            permission: ['flow-data'],
            hidden: true 
          }
        },
        {
          path: '/raw-data/mapping',
          name: 'RawDataMapping',
          // 直接使用RouterView组件
          component: RouterView,
          meta: {
            title: '零售终端映射配置',
            keepAlive: true,
            permission: ['flow-data']
          },
          redirect: '/raw-data/mapping/template-config',
          children: [
            {
              path: '/raw-data/mapping/template-config',
              name: 'TemplateConfig',
              component: () => import('@/views/raw-data/mapping/template-config'),
              meta: {
                title: '零售终端映射模板列表',
                keepAlive: true,
                permission: ['flow-data'],
                icon: 'TableOutlined'
              }
            }
          ]
        }
      ]
    }
  ]
}

export default flowDataRoutes 